// extracted by mini-css-extract-plugin
export default {"zoomModal":"G2-z","image":"H2-z","button":"I2-z","isOverlayShown":"J2-z"};